import { Cookies } from './Cookies'

let instanceCache: Cookies | null = null

/**
 * Return and cache the FWN Cookies instance.
 */
export function instanceGetter() {
  return instanceCache ?? (instanceCache = new Cookies())
}
